import { render, staticRenderFns } from "./EfsMdFarmerList.vue?vue&type=template&id=5950a954&scoped=true&"
import script from "./EfsMdFarmerList.vue?vue&type=script&lang=js&"
export * from "./EfsMdFarmerList.vue?vue&type=script&lang=js&"
import style0 from "./EfsMdFarmerList.vue?vue&type=style&index=0&id=5950a954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5950a954",
  null
  
)

export default component.exports